<script>
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import Notice from '@/components/cars/edit/Notice.vue'
import { mergeDatData, requestDat } from '@/api/cars'
import { cashSave } from '@/helpers/utils'
import FormattingHelpers from '@/mixins/FormattingHelpers'

export default {
  components: {
    'mia-cancel-button': CancelButton,
    'mia-notice': Notice,
    'mia-submit-button': SubmitButton
  },

  mixins: [FormattingHelpers],

  props: {
    car: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      step: 'idle',
      datResult: null,
      mobileOptions: {
        airbags: [],
        availableFeatures: [],
        bendinglightstypes: [],
        breakdownservices: [],
        carInteriorColors: [],
        carInteriorTypes: [],
        categories: [],
        certificate_slots: [],
        climatisations: [],
        colors: [],
        daytimerunninglamps: [],
        deliveryPeriods: [],
        doors: [],
        emissionClasses: [],
        emissionStickers: [],
        fuels: [],
        gearboxes: [],
        generalInspectionOptions: [],
        headlighttypes: [],
        makes: [],
        models: [],
        parkingAssistants: [],
        saleschannels: [],
        speedControls: [],
        stock_slots: [],
        trailerCouplingTypes: [],
        types: []
      },
      mobileTrimlines: [],
      mergableFields: [
        {
          id: 'item_shared_title',
          label: 'Fahrzeugtitel',
          carSource: 'item_shared_title',
          datSource: 'salesDescription',
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.trimline',
          label: 'Ausstattungslinie',
          carSource: () => this.car.item_mobilede_data.trimline || '',
          datSource: () => {
            const datValue = this.datResult.subModelName || ''

            if (!datValue) {
              return ''
            }

            if (!this.mobileTrimlines.includes(datValue)) {
              return ''
            }

            return datValue
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.airbag',
          label: 'Airbags',
          carSource: () => this.car.item_mobilede_data.airbag || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedAirbag = this.mobileOptions.airbags.find(airbag => airbag.name === value)

            if (!selectedAirbag) {
              return ''
            }

            return selectedAirbag.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.airbag || ''

            if (!datValue) {
              return ''
            }

            const validAirbags = this.mobileOptions.airbags.map(item => item.name)

            if (!validAirbags.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedAirbag = this.mobileOptions.airbags.find(airbag => airbag.name === value)

            if (!selectedAirbag) {
              return ''
            }

            return selectedAirbag.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.climatisation',
          label: 'Klimatisierung',
          carSource: () => this.car.item_mobilede_data.climatisation || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedClimatisation = this.mobileOptions.climatisations.find(climatisation => climatisation.name === value)

            if (!selectedClimatisation) {
              return ''
            }

            return selectedClimatisation.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.climatisation || ''

            if (!datValue) {
              return ''
            }

            const validClimatisations = this.mobileOptions.climatisations.map(item => item.name)

            if (!validClimatisations.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedClimatisation = this.mobileOptions.climatisations.find(climatisation => climatisation.name === value)

            if (!selectedClimatisation) {
              return ''
            }

            return selectedClimatisation.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.exteriorColor',
          label: 'Außenfarbe',
          carSource: () => this.car.item_mobilede_data.exteriorColor || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedExteriorColor = this.mobileOptions.colors.find(exteriorColor => exteriorColor.name === value)

            if (!selectedExteriorColor) {
              return ''
            }

            return selectedExteriorColor.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.exteriorColor || ''

            if (!datValue) {
              return ''
            }

            const validExteriorColors = this.mobileOptions.colors.map(item => item.name)

            if (!validExteriorColors.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedExteriorColor = this.mobileOptions.colors.find(exteriorColor => exteriorColor.name === value)

            if (!selectedExteriorColor) {
              return ''
            }

            return selectedExteriorColor.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.interiorColor',
          label: 'Innenfarbe',
          carSource: () => this.car.item_mobilede_data.interiorColor || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedInteriorColor = this.mobileOptions.carInteriorColors.find(interiorColor => interiorColor.name === value)

            if (!selectedInteriorColor) {
              return ''
            }

            return selectedInteriorColor.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.interiorColor || ''

            if (!datValue) {
              return ''
            }

            const validInteriorColors = this.mobileOptions.carInteriorColors.map(item => item.name)

            if (!validInteriorColors.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedInteriorColor = this.mobileOptions.carInteriorColors.find(interiorColor => interiorColor.name === value)

            if (!selectedInteriorColor) {
              return ''
            }

            return selectedInteriorColor.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.manufacturerColorName',
          label: 'Hersteller Farbbezeichnung',
          carSource: () => this.car.item_mobilede_data.manufacturerColorName || '',
          datSource: () => {
            const datValue = this.datResult.mobileData.manufacturerColorName || ''

            if (!datValue) {
              return ''
            }

            return datValue
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.interiorType',
          label: 'Innenausstattung',
          carSource: () => this.car.item_mobilede_data.interiorType || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedInteriorType = this.mobileOptions.carInteriorTypes.find(interiorType => interiorType.name === value)

            if (!selectedInteriorType) {
              return ''
            }

            return selectedInteriorType.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.interiorType || ''

            if (!datValue) {
              return ''
            }

            const validInteriorTypes = this.mobileOptions.carInteriorTypes.map(item => item.name)

            if (!validInteriorTypes.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedInteriorType = this.mobileOptions.carInteriorTypes.find(interiorType => interiorType.name === value)

            if (!selectedInteriorType) {
              return ''
            }

            return selectedInteriorType.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.headlightType',
          label: 'Scheinwerfer',
          carSource: () => this.car.item_mobilede_data.headlightType || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedHeadlightType = this.mobileOptions.headlighttypes.find(headlightType => headlightType.name === value)

            if (!selectedHeadlightType) {
              return ''
            }

            return selectedHeadlightType.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.headlightType || ''

            if (!datValue) {
              return ''
            }

            const validHeadlightTypes = this.mobileOptions.headlighttypes.map(item => item.name)

            if (!validHeadlightTypes.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedHeadlightType = this.mobileOptions.headlighttypes.find(headlightType => headlightType.name === value)

            if (!selectedHeadlightType) {
              return ''
            }

            return selectedHeadlightType.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.bendingLightsType',
          label: 'Kurvenlicht',
          carSource: () => this.car.item_mobilede_data.bendingLightsType || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedBendingLightsType = this.mobileOptions.bendinglightstypes.find(bendingLightsType => bendingLightsType.name === value)

            if (!selectedBendingLightsType) {
              return ''
            }

            return selectedBendingLightsType.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.bendingLightsType || ''

            if (!datValue) {
              return ''
            }

            const validBendingLightsTypes = this.mobileOptions.bendinglightstypes.map(item => item.name)

            if (!validBendingLightsTypes.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedBendingLightsType = this.mobileOptions.bendinglightstypes.find(bendingLightsType => bendingLightsType.name === value)

            if (!selectedBendingLightsType) {
              return ''
            }

            return selectedBendingLightsType.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.daytimeRunningLamps',
          label: 'Tagfahrlicht',
          carSource: () => this.car.item_mobilede_data.daytimeRunningLamps || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedDaytimeRunningLamps = this.mobileOptions.daytimerunninglamps.find(daytimeRunningLamp => daytimeRunningLamp.name === value)

            if (!selectedDaytimeRunningLamps) {
              return ''
            }

            return selectedDaytimeRunningLamps.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.daytimeRunningLamps || ''

            if (!datValue) {
              return ''
            }

            const validDaytimeRunningLamps = this.mobileOptions.daytimerunninglamps.map(item => item.name)

            if (!validDaytimeRunningLamps.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedDaytimeRunningLamps = this.mobileOptions.daytimerunninglamps.find(daytimeRunningLamp => daytimeRunningLamp.name === value)

            if (!selectedDaytimeRunningLamps) {
              return ''
            }

            return selectedDaytimeRunningLamps.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.trailerCoupling',
          label: 'Anhängerkupplung',
          carSource: () => this.car.item_mobilede_data.trailerCoupling || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedTrailerCouplingType = this.mobileOptions.trailerCouplingTypes.find(trailerCouplingType => trailerCouplingType.name === value)

            if (!selectedTrailerCouplingType) {
              return ''
            }

            return selectedTrailerCouplingType.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.trailerCoupling || ''

            if (!datValue) {
              return ''
            }

            const validTrailerCouplingTypes = this.mobileOptions.trailerCouplingTypes.map(item => item.name)

            if (!validTrailerCouplingTypes.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedTrailerCouplingType = this.mobileOptions.trailerCouplingTypes.find(trailerCouplingType => trailerCouplingType.name === value)

            if (!selectedTrailerCouplingType) {
              return ''
            }

            return selectedTrailerCouplingType.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.radio',
          label: 'Radio',
          carSource: () => this.car.item_mobilede_data.radio || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedRadio = this.mobileOptions.radioTypes.find(radio => radio.name === value)

            if (!selectedRadio) {
              return ''
            }

            return selectedRadio.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.radio || ''

            if (!datValue) {
              return ''
            }

            const validRadios = this.mobileOptions.radioTypes.map(item => item.name)

            if (!validRadios.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedRadio = this.mobileOptions.radioTypes.find(radio => radio.name === value)

            if (!selectedRadio) {
              return ''
            }

            return selectedRadio.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.speedControl',
          label: 'Tempomat',
          carSource: () => this.car.item_mobilede_data.speedControl || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedSpeedControl = this.mobileOptions.speedControls.find(speedControl => speedControl.name === value)

            if (!selectedSpeedControl) {
              return ''
            }

            return selectedSpeedControl.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.speedControl || ''

            if (!datValue) {
              return ''
            }

            const validSpeedControls = this.mobileOptions.speedControls.map(item => item.name)

            if (!validSpeedControls.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedSpeedControl = this.mobileOptions.speedControls.find(speedControl => speedControl.name === value)

            if (!selectedSpeedControl) {
              return ''
            }

            return selectedSpeedControl.description || ''
          },
          selectedValue: ''
        },
        {
          id: 'item_mobilede_data.breakdownService',
          label: 'Pannenhilfe',
          carSource: () => this.car.item_mobilede_data.breakdownService || '',
          carSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedBreakdownService = this.mobileOptions.breakdownservices.find(breakdownService => breakdownService.name === value)

            if (!selectedBreakdownService) {
              return ''
            }

            return selectedBreakdownService.description || ''
          },
          datSource: () => {
            const datValue = this.datResult.mobileData.breakdownService || ''

            if (!datValue) {
              return ''
            }

            const validBreakdownServices = this.mobileOptions.breakdownservices.map(item => item.name)

            if (!validBreakdownServices.includes(datValue)) {
              return ''
            }

            return datValue
          },
          datSourceLabel: (value) => {
            if (!value) {
              return ''
            }

            const selectedBreakdownService = this.mobileOptions.breakdownservices.find(breakdownService => breakdownService.name === value)

            if (!selectedBreakdownService) {
              return ''
            }

            return selectedBreakdownService.description || ''
          },
          selectedValue: ''
        }
      ],
      selectedParkingAssistants: [],
      selectedMobileFeatures: [],
      selectedConfiguration: []
    }
  },

  computed: {
    returnedMobileOptions() {
      if (!this.datResult) {
        return []
      }

      return Object.keys(this.datResult.mobileData).filter(key => key !== 'feature')
    },

    returnedMobileFeatures() {
      if (!this.datResult) {
        return []
      }

      return Object.keys(this.datResult.mobileData.feature || {})
    },

    returnedMobileFeaturesNotSelected() {
      return this.returnedMobileFeatures.filter(feature => !this.selectedMobileFeatures.includes(feature))
    },

    returnedMobileParkingAssistants() {
      if (!this.datResult) {
        return []
      }

      return this.datResult.mobileData.parkingAssistants || []
    },

    returnedMobileParkingAssistantsNotSelected() {
      return this.returnedMobileParkingAssistants.filter(parkingAssistant => !this.selectedParkingAssistants.includes(parkingAssistant))
    },

    carMobileFeatures() {
      return this.car.item_mobilede_data.feature
    },

    returnedConfiguration() {
      if (!this.datResult) {
        return []
      }

      let configuration = [];

      (this.datResult.seriesEquipment || []).forEach((item) => {
        configuration.push({
          item_type: 'series',
          item_id: item.manufacturerEquipmentId || '',
          item_dat_id: item.datEquipmentId || '0',
          item_title: item.description || item.manufacturerDescription || '',
          item_price: item.originalPrice || '',
          item_dat_group: item.equipmentGroup || ''
        })

        if (item.containedEquipment && item.containedEquipment.length > 0) {
          item.containedEquipment.forEach((containedItem) => {
            configuration.push({
              item_type: 'series',
              item_id: containedItem.manufacturerEquipmentId || '',
              item_dat_id: containedItem.datEquipmentId || '0',
              item_title: containedItem.description || containedItem.manufacturerDescription || '',
              item_price: containedItem.originalPrice || '',
              item_dat_group: containedItem.equipmentGroup || ''
            })
          })
        }
      });

      (this.datResult.specialEquipment || []).forEach((item) => {
        configuration.push({
          item_type: 'option',
          item_id: item.manufacturerEquipmentId || '',
          item_dat_id: item.datEquipmentId || '0',
          item_title: item.description || item.manufacturerDescription || '',
          item_price: item.originalPrice || '',
          item_dat_group: item.equipmentGroup || ''
        })

        if (item.containedEquipment && item.containedEquipment.length > 0) {
          item.containedEquipment.forEach((containedItem) => {
            configuration.push({
              item_type: 'option',
              item_id: containedItem.manufacturerEquipmentId || '',
              item_dat_id: containedItem.datEquipmentId || '0',
              item_title: containedItem.description || containedItem.manufacturerDescription || '',
              item_price: containedItem.originalPrice || '',
              item_dat_group: containedItem.equipmentGroup || ''
            })
          })
        }
      });

      (this.datResult.vinEquipments || []).forEach((item) => {
        configuration.push({
          item_type: 'property',
          item_id: item.manufacturerCode || '',
          item_dat_id: item.avNumberDat || '0',
          item_title: item.shortName || '',
          item_price: '',
          item_dat_group: ''
        })
      });

      (this.datResult.vinColors || []).forEach((item) => {
        configuration.push({
          item_type: 'color',
          item_id: item.colorId || '',
          item_dat_id: item.code || '0',
          item_title: item.description || '',
          item_price: '',
          item_dat_group: ''
        })
      })

      configuration = configuration.map((item) => {
        if (/Garantie/i.test(item.item_title)) {
          return {
            ...item,
            item_type: 'warranty'
          }
        }

        return item
      })

      return configuration
    },

    returnedConfigurationNotSelected() {
      return this.returnedConfiguration.filter((item) => {
        const existingItem = this.selectedConfiguration.find(selectedItem => selectedItem.item_id === item.item_id)

        if (existingItem) {
          return false
        }

        return true
      })
    }
  },

  methods: {
    cashSave,

    async onRequestDat() {
      if (this.$wait.is('requesting dat')) {
        return
      }

      this.$wait.start('requesting dat')
      const [error, response] = await requestDat(this.car.id)
      this.$wait.end('requesting dat')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['DAT-Abfrage fehlgeschlagen']
        })
        return
      }

      this.datResult = response.data
      this.step = 'merge'
      await this.loadMobileOptions()
      this.prefillSelectedValues()
    },

    async onSaveDat() {
      if (this.$wait.is('saving dat data')) {
        return
      }

      this.$wait.start('saving dat data')
      const payload = {
        fields: this.mergableFields.map(field => ({ id: field.id, value: field.selectedValue })),
        parkingAssistants: this.selectedParkingAssistants,
        mobileFeatures: this.selectedMobileFeatures,
        configuration: this.selectedConfiguration
      }
      const [error] = await mergeDatData(this.car.id, payload)
      this.$wait.end('saving dat data')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Übernehmen der Daten']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Daten erfolgreich übernommen']
      })
      this.$emit('done')
    },

    async loadMobileOptions() {
      this.$wait.start('loading mobile options')

      await Promise.allSettled([
        axios.get(`${window.baseUrl}/car/mobileoptions/${this.carId}`)
          .then(({ data }) => {
            this.mobileOptions = { ...this.options, ...data }
          })
          .catch((e) => {
            console.log(e)
          }),
        axios.get(`${window.baseUrl}/car/trimlines/${this.car.item_mobile_make}/${this.car.item_mobile_model}`)
          .then(({ data }) => {
            this.mobileTrimlines = data.values.map(trimline => trimline.name)
          })
          .catch((e) => {
            console.log(e)
          })
      ])

      this.$wait.end('loading mobile options')
    },

    prefillSelectedValues() {
      // Mergable fields
      this.mergableFields = this.mergableFields.map(mergableField => ({
        ...mergableField,
        selectedValue: this.getCarSourceValue(mergableField)
      }))

      // mobile.de features
      this.selectedMobileFeatures = Object.entries(this.carMobileFeatures).filter(([, value]) => value === 'true' || value === 1 || value === true).map(([feature]) => feature)

      // mobile.de parking assistants
      this.selectedParkingAssistants = this.car.item_mobilede_data.parkingAssistants || []

      // configuration
      this.selectedConfiguration = this.car.item_configuration || []
    },

    onFeatureInput(feature, event) {
      if (event.target.checked) {
        this.selectedMobileFeatures = [...this.selectedMobileFeatures, feature]
        return
      }

      this.selectedMobileFeatures = this.selectedMobileFeatures.filter(selectedFeature => feature !== selectedFeature)
    },

    getCarSourceValue(mergableField) {
      if (typeof mergableField.carSource === 'string') {
        return this.car[mergableField.carSource] || ''
      }

      if (typeof mergableField.carSource === 'function') {
        return mergableField.carSource() || ''
      }

      return ''
    },

    getCarSourceLabel(mergableField) {
      if (mergableField.carSourceLabel === undefined) {
        return this.getCarSourceValue(mergableField)
      }

      if (typeof mergableField.carSourceLabel === 'string') {
        return mergableField.carSourceLabel
      }

      if (typeof mergableField.carSourceLabel === 'function') {
        return mergableField.carSourceLabel(this.getCarSourceValue(mergableField)) || ''
      }

      return ''
    },

    getDatSourceValue(mergableField) {
      if (!this.datResult) {
        return ''
      }

      if (typeof mergableField.datSource === 'string') {
        return this.datResult[mergableField.datSource] || ''
      }

      if (typeof mergableField.datSource === 'function') {
        return mergableField.datSource() || ''
      }

      return ''
    },

    getDatSourceLabel(mergableField) {
      if (mergableField.datSourceLabel === undefined) {
        return this.getDatSourceValue(mergableField)
      }

      if (typeof mergableField.datSourceLabel === 'string') {
        return mergableField.datSourceLabel
      }

      if (typeof mergableField.datSourceLabel === 'function') {
        return mergableField.datSourceLabel(this.getDatSourceValue(mergableField)) || ''
      }

      return ''
    },

    selectMergableFieldValue(mergableField, value) {
      this.mergableFields = this.mergableFields.map((existingMergableField) => {
        if (existingMergableField.id === mergableField.id) {
          return {
            ...existingMergableField,
            selectedValue: value
          }
        }

        return existingMergableField
      })
    },

    isCarSourceValueSelected(mergableField) {
      return mergableField.selectedValue === this.getCarSourceValue(mergableField)
    },

    isDatSourceValueSelected(mergableField) {
      return mergableField.selectedValue === this.getDatSourceValue(mergableField)
    },

    selectMobileFeature(feature) {
      this.selectedMobileFeatures = [...this.selectedMobileFeatures, feature]
    },

    onParkingAssistantInput(parkingAssistant, event) {
      if (event.target.checked) {
        this.selectedParkingAssistants = [...this.selectedParkingAssistants, parkingAssistant.name]
        return
      }

      this.selectedParkingAssistants = this.selectedParkingAssistants.filter(selectedParkingAssistant => selectedParkingAssistant !== parkingAssistant.name)
    },

    getParkingAssistantLabel(parkingAssistant) {
      return this.mobileOptions.parkingAssistants.find(parkingAssistant)?.description || parkingAssistant
    },

    selectMobileParkingAssistant(parkingAssistant) {
      this.selectedParkingAssistants = [...this.selectedParkingAssistants, parkingAssistant]
    },

    getEquipmentTypeLabel(equipmentType) {
      return {
        color: 'Farbe',
        interior: 'Interieur',
        series: 'Serienausstattung',
        option: 'Sonderausstattung',
        property: 'Eigenschaft',
        attribute: 'Attribut',
        warranty: 'Garantie'
      }[equipmentType] || equipmentType
    },

    selectConfiguration(configItem) {
      this.selectedConfiguration = [...this.selectedConfiguration, configItem]
    },

    selectAllConfiguration() {
      this.selectedConfiguration = [...this.selectedConfiguration, ...this.returnedConfigurationNotSelected]
    }
  }
}
</script>

<template>
  <mia-modal
    id="car-dat-modal"
    classes="v--modal flex flex-col"
    width="60%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        DAT-Abfrage
      </h3>
    </mia-modal-header>

    <div class="p-4">
      <template v-if="step === 'idle'">
        <mia-notice permanent>
          Bitte bestätigen Sie die <strong>kostenpflichtige DAT-Abfrage</strong> für das gewählte Fahrzeug.
        </mia-notice>
      </template>
      <template v-else-if="step === 'merge'">
        <mia-wait for="loading mobile options">
          <template #waiting>
            <div class="flex items-center justify-center py-8">
              <mia-wave-loader />
            </div>
          </template>

          <template #default>
            <div>
              <mia-notice
                permanent
                class="mb-8"
              >
                Bitte wählen Sie jeweils aus, welche Daten am Fahrzeug übernommen werden sollen.
              </mia-notice>

              <div
                v-for="mergableField in mergableFields"
                :key="mergableField.id"
              >
                <div class="text-lg">
                  {{ mergableField.label }}
                </div>
                <div class="flex mt-2 border-b border-gray-400 pb-4 mb-4">
                  <div class="w-1/2 pr-4">
                    <div class="text-sm font-bold">
                      Aktueller Wert
                    </div>
                    <button
                      type="button"
                      class="flex items-start text-left p-2 border rounded focus:outline-none w-full"
                      :class="isCarSourceValueSelected(mergableField) ? 'border-orange-mia' : 'border-transparent hover:border-orange-mia'"
                      @click="selectMergableFieldValue(mergableField, getCarSourceValue(mergableField))"
                    >
                      <span
                        v-if="isCarSourceValueSelected(mergableField)"
                        class="flex-shrink-0 text-green-600 mr-2"
                      >
                        <mia-streamline-icon
                          class="w-5 h-5 fill-current"
                          src="check-circle-1"
                        />
                      </span>
                      <div>
                        <template v-if="getCarSourceValue(mergableField) === ''">
                          <span class="italic">(leer)</span>
                        </template>
                        <template v-else>
                          {{ getCarSourceLabel(mergableField) }}
                        </template>
                      </div>
                    </button>
                  </div>
                  <div class="w-1/2 pl-4">
                    <div class="text-sm font-bold">
                      DAT Wert
                    </div>
                    <button
                      type="button"
                      class="flex items-start text-left p-2 border rounded focus:outline-none w-full"
                      :class="isDatSourceValueSelected(mergableField) ? 'border-orange-mia' : 'border-transparent hover:border-orange-mia'"
                      @click="selectMergableFieldValue(mergableField, getDatSourceValue(mergableField))"
                    >
                      <span
                        v-if="isDatSourceValueSelected(mergableField)"
                        class="flex-shrink-0 text-green-600 mr-2"
                      >
                        <mia-streamline-icon
                          class="w-5 h-5 fill-current"
                          src="check-circle-1"
                        />
                      </span>
                      <div>
                        <template v-if="getDatSourceValue(mergableField) === ''">
                          <span class="italic">(leer)</span>
                        </template>
                        <template v-else>
                          {{ getDatSourceLabel(mergableField) }}
                        </template>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="border-b border-gray-400 pb-4 mb-4">
              <div class="text-lg">
                Einparkhilfen
              </div>
              <div class="mt-2">
                <div class="text-sm font-bold">
                  Aktuell gewählte Einparkhilfen
                </div>
                <div class="grid grid-cols-4 gap-4">
                  <div
                    v-for="parkingAssistant in mobileOptions.parkingAssistants"
                    :key="parkingAssistant.name"
                  >
                    <label class="cursor-pointer font-normal flex items-center">
                      <input
                        value="1"
                        type="checkbox"
                        :checked="selectedParkingAssistants.includes(parkingAssistant.name)"
                        @input="onParkingAssistantInput(parkingAssistant, $event)"
                      >
                      <span
                        class="ml-2 block mt-px"
                        v-html="parkingAssistant.description"
                      />
                    </label>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div class="font-bold text-sm">
                  DAT Einparkhilfen
                </div>
                <ul
                  v-if="returnedMobileParkingAssistantsNotSelected.length > 0"
                  class="mt-2 divide-y divide-gray-200"
                >
                  <li
                    v-for="parkingAssistant in returnedMobileParkingAssistantsNotSelected"
                    :key="parkingAssistant"
                    class="flex py-2"
                  >
                    <div class="flex-1">
                      {{ getParkingAssistantLabel(parkingAssistant) }}
                    </div>
                    <button
                      type="button"
                      class="bg-orange-mia text-white hover:bg-orange-mia-dark focus:outline-none px-3 py-2 rounded-sm"
                      @click="selectMobileParkingAssistant(parkingAssistant)"
                    >
                      Hinzufügen
                    </button>
                  </li>
                </ul>
                <div
                  v-else
                  class="mt-2 italic"
                >
                  (leer)
                </div>
              </div>
            </div>

            <div class="border-b border-gray-400 pb-4 mb-4">
              <div class="text-lg">
                Ausstattung
              </div>
              <div class="mt-2">
                <div class="text-sm font-bold">
                  Aktuell gewählte Ausstattungen
                </div>
                <div class="grid grid-cols-4 gap-4">
                  <div
                    v-for="(label, feature) in mobileOptions.availableFeatures"
                    :key="feature"
                  >
                    <label class="cursor-pointer font-normal flex items-center">
                      <input
                        value="1"
                        type="checkbox"
                        :checked="selectedMobileFeatures.includes(feature)"
                        @input="onFeatureInput(feature, $event)"
                      >
                      <span
                        class="ml-2 block mt-px"
                        v-html="label"
                      />
                    </label>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div class="font-bold text-sm">
                  DAT Ausstattungen
                </div>
                <ul
                  v-if="returnedMobileFeaturesNotSelected.length > 0"
                  class="mt-2 divide-y divide-gray-200"
                >
                  <li
                    v-for="feature in returnedMobileFeaturesNotSelected"
                    :key="feature"
                    class="flex py-2"
                  >
                    <div class="flex-1">
                      {{ mobileOptions.availableFeatures[feature] }}
                    </div>
                    <button
                      type="button"
                      class="bg-orange-mia text-white hover:bg-orange-mia-dark focus:outline-none px-3 py-2 rounded-sm"
                      @click="selectMobileFeature(feature)"
                    >
                      Hinzufügen
                    </button>
                  </li>
                </ul>
                <div
                  v-else
                  class="mt-2 italic"
                >
                  (leer)
                </div>
              </div>
            </div>

            <div class="border-b border-gray-400 pb-4 mb-4">
              <div class="text-lg">
                Konfiguration
              </div>
              <div class="mt-2">
                <div class="text-sm font-bold">
                  Aktuell gewählte Konfiguration
                </div>
                <table class="datatable w-full">
                  <thead>
                    <tr>
                      <th>Typ</th>
                      <th>DAT ID</th>
                      <th>DAT Gruppe</th>
                      <th>Hersteller ID</th>
                      <th>Bezeichnung</th>
                      <th>Preis</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="configItem in selectedConfiguration"
                      :key="`${configItem.id}-${configItem.item_id}-${configItem.item_dat_id}`"
                    >
                      <td>{{ getEquipmentTypeLabel(configItem.item_type) }}</td>
                      <td>{{ configItem.item_dat_id }}</td>
                      <td>{{ configItem.item_dat_group }}</td>
                      <td>{{ configItem.item_id }}</td>
                      <td>{{ configItem.item_title }}</td>
                      <td>
                        {{ configItem.item_price ? formatAsCurrency(parseFloat(configItem.item_price)) : '0,00 €' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mt-4">
                <div class="font-bold text-sm">
                  DAT Ausstattungen
                </div>
                <table
                  v-if="returnedConfigurationNotSelected.length > 0"
                  class="datatable w-full"
                >
                  <thead>
                    <tr>
                      <th>Typ</th>
                      <th>DAT ID</th>
                      <th>DAT Gruppe</th>
                      <th>Hersteller ID</th>
                      <th>Bezeichnung</th>
                      <th>Preis</th>
                      <th class="flex justify-end">
                        <button
                          type="button"
                          class="bg-orange-mia text-white hover:bg-orange-mia-dark focus:outline-none px-3 py-2 rounded-sm"
                          @click="selectAllConfiguration"
                        >
                          Alle Hinzufügen
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="configItem in returnedConfigurationNotSelected"
                      :key="`${configItem.id}-${configItem.item_id}-${configItem.item_dat_id}`"
                    >
                      <td>{{ getEquipmentTypeLabel(configItem.item_type) }}</td>
                      <td>{{ configItem.item_dat_id }}</td>
                      <td>{{ configItem.item_dat_group }}</td>
                      <td>{{ configItem.item_id }}</td>
                      <td>{{ configItem.item_title }}</td>
                      <td>
                        {{ configItem.item_price ? formatAsCurrency(parseFloat(configItem.item_price)) : '0,00 €' }}
                      </td>
                      <td class="flex justify-end">
                        <button
                          type="button"
                          class="bg-orange-mia text-white hover:bg-orange-mia-dark focus:outline-none px-3 py-2 rounded-sm"
                          @click="selectConfiguration(configItem)"
                        >
                          Hinzufügen
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  v-else
                  class="mt-2 italic"
                >
                  (leer)
                </div>
              </div>
            </div>
          </template>
        </mia-wait>
      </template>
    </div>

    <mia-modal-footer class="flex items-center justify-end">
      <mia-cancel-button
        label="Abbrechen"
        type="button"
        :disabled="$wait.any"
        size="small"
        @click="$emit('cancel')"
      />

      <template v-if="step === 'idle'">
        <mia-submit-button
          label="DAT-Abfrage kaufen"
          type="button"
          class="ml-3"
          :disabled="$wait.any"
          size="small"
          @click="onRequestDat"
        />
      </template>
      <template v-else-if="step === 'merge'">
        <mia-submit-button
          label="Daten speichern"
          type="button"
          class="ml-3"
          :disabled="$wait.any"
          size="small"
          :is-loading="$wait.is('saving dat data')"
          @click="onSaveDat"
        />
      </template>
    </mia-modal-footer>
  </mia-modal>
</template>
